import { OnChanges, viewChild } from '@angular/core';
import { Component, Input, OnInit } from '@angular/core';
import { Filter } from 'src/app/api/api-campaigns.service.generated';
import { FiltersEditComponent } from './filters-edit/filters-edit.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-filter-strategy-edit',
  templateUrl: './filter-strategy-edit.component.html',
  styleUrls: ['./filter-strategy-edit.component.scss'],
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    FiltersEditComponent
  ]
})
export class FilterStrategyEditComponent implements OnInit, OnChanges {

  @Input() strategy: Filter;

  readonly filtersEdit = viewChild<FiltersEditComponent>('filtersEdit');

  constructor() { }

  ngOnChanges(): void {
    if (!this.strategy) return;
    if (this.strategy && !this.strategy.consumptionFilters)
      this.strategy.consumptionFilters = [];
  }

  ngOnInit() { }

}
